// extracted by mini-css-extract-plugin
module.exports = {"graphLoaderIcon":"MultiBarGraph_graphLoaderIcon__1nRAL Graphs_graphLoaderIcon__rCc2Q"};